import type { VehiclesGroup } from '@cobliteam/api-lib/src/__generated__/graphql';
import type { StateCreator } from 'zustand';

export interface GlobalFilterSliceState {
  // @deprecated should use filteredGroups instead
  vehicleGroupIds: string[];
  // @deprecated should use setFilteredGroups instead
  setVehicleGroupIds: (vehicleGroupIds: string[]) => void;
  filteredGroups: VehiclesGroup[];
  setFilteredGroups: (filteredGroups: VehiclesGroup[]) => void;
}

type StateCreatorGlobalFilter = StateCreator<GlobalFilterSliceState>;

const initialStates = {
  vehicleGroupIds: [],
  filteredGroups: [],
};

const createGlobalFilterSlice: StateCreatorGlobalFilter = (set) => ({
  ...initialStates,
  setVehicleGroupIds: (vehicleGroupIds: string[]) => set({ vehicleGroupIds }),
  setFilteredGroups: (filteredGroups: VehiclesGroup[]) => set({ filteredGroups }),
});

export default createGlobalFilterSlice;
